module.exports = __webpack_public_path__ + "static/media/plane.902b6b81.png";